import React from "react";
import { CheckboxInput } from "@fidget/common/components/form/checkboxInput";
import styles from "./simpleCheckboxPlaceholder.css";
import { VerticalSeparator } from "../separators/verticalSeparator/verticalSeparator";
import { L10nId } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";

interface Props extends React.PropsWithChildren<{}> {
  value: boolean;
  id: string;
  labelId: L10nId;
  onChange: (value: boolean) => void;
}

export const SimpleCheckboxPlaceholder = ({ value, id, labelId, onChange, children }: Props) => {
  return (
    <div className={styles.container}>
      {children}
      <div style={{ alignSelf: "stretch" }}>
        <VerticalSeparator />
      </div>
      <CheckboxInput
        value={value}
        id={id}
        label={intl.formatMessage(labelId)}
        onChange={onChange}
        smallStyle
        displayNoColors
        noMarginBottom
      />
    </div>
  );
};
